<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="د.مجدي-عز-الدين-حنفي">
<h1><span dir="rtl">د.مجدي عز الدين حنفي</span></h1>
<p><span dir="rtl">د. مجدي عز الدين حنفي.</span></p>
<ul class="liststyle">
<li><p><span dir="rtl">استشاري الجراحة بإنجلترا.</span></p></li>
<li><p><span dir="rtl">بكالوريوس طب وجراحة.. كلية الطب - جامعة الأزهر (تقدير امتياز مع مرتبة الشرف).</span></p></li>
<li><p><span dir="rtl">زميل الكليات الملكية للجراحين بالمملكة المتحدة.</span></p></li>
<li><p><span dir="rtl">مؤلف كتاب "كيف خلقَنا الله سبحانه وتعالى"، مكتبة الأنجلو المصرية 2006.</span></p></li>
</ul>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?331bad7d